﻿import { Component, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { AuthenticationService } from './_services';
import { User } from './_models';
import { RestService } from './_services/rest.service';
import { DOCUMENT } from '@angular/common';
import { GoogleAnalyticsService } from './_services/analytics.service';

@Component({
    selector: 'app-root', templateUrl: 'app.component.html'

})
export class AppComponent {

    currentUser: User;



    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private restService: RestService,
        private googleAnalyticsService: GoogleAnalyticsService,
        @Inject(DOCUMENT) document) {

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                let ruta = event.urlAfterRedirects;
                if (!ruta.includes("#")) {
                    const index = ruta.indexOf("?");
                    if (index > 0) {
                        ruta = ruta.substr(0, index);
                    }
                    this.googleAnalyticsService.routeEmitter('UA-172690204-1', ruta);
                }
            }
        });


        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.restService.getParam('mail').subscribe(data => {
            if (data && data.valor) {
                const mail = document.getElementById('mail') as HTMLElement;
                //mail.innerText = data.valor;
                mail.setAttribute('href', 'mailto:' + data.valor);
            }
        });

    }


    hasRol(rolName: string): boolean {
        return this.authenticationService.hasRol(rolName);
    }

    entrarOSalir() {
        if (this.currentUser) {
            this.authenticationService.logout();
            this.router.navigate(['/']);
        } else {
            this.router.navigate(['/login']);
        }
    }

    currentYear() {
        return (new Date()).getFullYear();
    }

    print() {
        window.print();
    }

}
